module.exports = __webpack_public_path__ + "img/sass.b446ca5a.svg";